import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
import { TabPanel, TabView } from 'primereact/tabview';
import {
  AcceptanceDocumentsChecker,
  DetailContract,
  MidtermDocumentsChecker,
} from 'features/SubmitProjectProposal/pages';
// import {
//   // MidtermDocumentReviewCouncil,
//   // MidtermCouncil,
//   // AcceptanceCouncil,
//   // AcceptanceDocumentReviewCouncil,
// } from 'features/Council/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import { AbilityContext } from 'components/Can';

function SubmitProjectProposalDetailPage() {
  const { t } = useTranslation();
  // const { state } = useLocation();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 0;

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <>
          <TabView
            activeIndex={parseInt(tab, 10)}
            onTabChange={(e) => navigate(`.?tab=${e.index}`)}
          >
            {ability.can('read', 'project') ? (
              <TabPanel header="Hợp đồng" leftIcon="pi pi-file mr-2">
                <DetailContract />
              </TabPanel>
            ) : (
              <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
            )}

            {ability.can('update', 'summary-report') && (
              <TabPanel header="Kiểm tra hồ sơ giữa kỳ" leftIcon="pi pi-list mr-2">
                <MidtermDocumentsChecker />
              </TabPanel>
            )}
            {/* {ability.can('read', 'council') && (
              <TabPanel header="Đánh giá giữa kỳ" leftIcon="pi pi-list mr-2">
                <MidtermCouncil />
              </TabPanel>
            )} */}
            {ability.can('update', 'summary-report') && (
              <TabPanel header="Kiểm tra hồ sơ nghiệm thu" leftIcon="pi pi-list mr-2">
                <AcceptanceDocumentsChecker />
              </TabPanel>
            )}
            {/* {ability.can('read', 'council') && (
              <TabPanel header="Nghiệm thu" leftIcon="pi pi-list mr-2">
                <AcceptanceCouncil />
              </TabPanel>
            )} */}

            {/* {ability.can('read', 'council') && (
              <TabPanel header="So sánh phiên bản" leftIcon="pi pi-list mr-2">
                <ReviseProjectProposalCompareDetail />
              </TabPanel>
            )} */}
            {/* /* {ability.can('read', 'council') && (
              <TabPanel header={t('council.header')} leftIcon="pi pi-list mr-2">
                <CouncilList />
              </TabPanel>
            )} */}
          </TabView>
          <ScrollTop target="parent" />
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default SubmitProjectProposalDetailPage;
